import { QueryClient } from '@tanstack/react-query';

const defaultQueryConfig = { staleTime: 60000 };

export const queryClient = new QueryClient({
    defaultOptions: { queries: defaultQueryConfig }
});

export const getQueryKeyBase = (baseKey, ...args) => {
    if (!args) {
        return [baseKey];
    }
    return [baseKey, ...args];
};

export const QUERY_KEYS = {
    CRITERIA_RESOURCES: 'criteria-resources',
    CRITERIA_RESOURCE: 'criteria-resource',
    CRITERIA_RESOURCE_TYPES: 'criteria-resource-types',
    CLASS_TYPES: 'class-types'
};

export const MUTATION_KEYS = {
    CRITERIA_RESOURCE: 'criteria-resource',
    CRITERIA_RESOURCES: 'criteria-resources'
};
